import socket from '../config/socket';
import { useEffect } from 'react';
import { useSignOut } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useAuthUser, useIsAuthenticated } from 'react-auth-kit';
// Компоненты пользовательского интерфейса
import '../styles/App.css';
import LanguageRefresher from './CustomElements/LanguageRefresher';
import Devices from './Devices/Devices';
import Brigades from './Brigades/Brigades';
import Documentation from './Documentation/Documentation';
import Infocards from './Infocards/Infocards';
import UippsMain from './UIPPS/UippsMain';
import Archive from './Archive/Archive';
import Login from './Login/Login';
import Navbar from './CustomElements/Navbar';
import Kuobzes from './Kuobz/Kuobzes';
import Reports from './Documentation/Reports';
import ArchiveBrigade from './Archive/ArchiveBrigade';
import AdminDataPanel from './AdminPanel/AdminDashboard';
import FileManager from './FileManager/FileManager';
import ErrorModal from './Modal/ErrorModal';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Кастомные хуки
import { useRole } from '../customHook/useRole';
import useClearStates from '../customHook/useClearStates';
import useOptionsLabelUpdater from '../customHook/useOptionsLabelUpdater';
// Действия Redux
import { loginUser } from '../redux/actions/user.action';
import { initOptionsFromServer } from '../redux/actions/options.action';
import { useInitLanguage } from '../customHook/useInitLanguage';

function App() {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signOut = useSignOut();
  const user = useSelector((state) => state.user);

  // инициализация языка
  useInitLanguage();
  // Получение текущего языка из Redux store
  const language = useSelector((state) => state.language);
  // обновление опций для селектов
  useOptionsLabelUpdater();

  const isAuthenticated = useIsAuthenticated();
  const authUser = useAuthUser(); // Получение роли текущего аутентифицированного пользователя.
  //проверяем роли пользователя
  const isAdmin = useRole('admin');
  const isUser = useRole('user');
  const isEngineer = useRole('engineer');
  const isReports = useRole('reports');
  const isCustomer = useRole('customer');
  const isEngineerInfosignal = useRole('engineerInfosignal');
  const isMaster = useRole('master');
  const isDispatcher = useRole('dispatcher');

  //определение страницы, для скрытия навбара на странице логина
  const location = useLocation();
  // определяем, находимся ли мы на странице логина
  const isLoginPage = location.pathname === '/login';

  // очищает стейты при переходе между страницами
  useClearStates(location.pathname);

  // если не авторизован то выходим из системы и редирект на логин
  useEffect(() => {
    if ((!user?.user && !isAuthenticated) || user?.logout) {
      signOut();
      navigate('/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // если есть данные о пользователе при перезагрузке страницы записываем их в стейт
  useEffect(() => {
    const user = authUser();
    if (user) {
      dispatch(loginUser(user));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const user = authUser();
    if (user) {
      //получаем опции для селектов
      dispatch(initOptionsFromServer());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //подключение сокета после перезагрузки страницы
  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    // Проверяем наличие токенов и что сокет еще не подключен
    if (accessToken && refreshToken && !socket.connected) {
      socket.auth = { token: accessToken, refreshToken: refreshToken }; // Установка токена для сокета
      socket.connect(); // Подключаем сокет
    }
  }, []);

  return (
    <div className="App">
      {!isLoginPage && <Navbar />} {/* Не отображать Navbar на странице логина */}
      <LanguageRefresher key={language}>
        <Routes>
          {!isAuthenticated() && (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
          {(isAdmin || isUser || isCustomer || isEngineerInfosignal || isMaster || isDispatcher) && (
            <Route path="/brigades" element={<Brigades />} />
          )}
          {(isAdmin || isEngineerInfosignal || isDispatcher || isMaster) && (
            <>
              <Route path="/devices" element={<Devices />} />
              <Route path="/documentation" element={<Documentation />} />
              <Route path="/infocards/*" element={<Infocards />} />
              <Route path="/uipps" element={<UippsMain />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/files" element={<FileManager />} />
              <Route path="/administrate" element={<AdminDataPanel />} />
              <Route path="/archive/:id" element={<ArchiveBrigade />} />
              <Route path="/file" element={<FileManager />} />
              <Route path="*" element={<Navigate to="/devices" />} />
            </>
          )}

          {isEngineer && (
            <>
              <Route path="/kuobz" element={<Kuobzes />} />
              <Route path="*" element={<Navigate to="/kuobz" />} />
            </>
          )}
          {isReports && (
            <>
              <Route path="/reports" element={<Reports />} />
              <Route path="*" element={<Navigate to="/reports" />} />
            </>
          )}
          {isCustomer && (
            <>
              <Route path="/reports" element={<Reports />} />
              <Route path="*" element={<Navigate to="/reports" />} />
            </>
          )}
          {isUser && <Route path="*" element={<Navigate to="/brigades" />} />}
        </Routes>
      </LanguageRefresher>
      <ErrorModal width="var(--sadr-font-size-600)" height="18.75rem" />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        transition={Slide}
      />
    </div>
  );
}

export default App;
